const isDev = import.meta.env.DEV;

const DEV_WS_URL = "ws://localhost:8000/ws/widgets/";
const DEV_TOKEN_API_URL = "http://localhost:8000/api/widgets/__dev__/token/";

function getWebSocketUrl(): string {
  if (isDev) {
    return DEV_WS_URL;
  }
  const prodUrl = import.meta.env.VITE_WEBSOCKETS_URL as string | undefined;
  if (prodUrl) {
    return prodUrl;
  }
  return DEV_WS_URL;
}

function getTokenApiUrl(): string {
  if (isDev) {
    return DEV_TOKEN_API_URL;
  }
  const wsUrl = import.meta.env.VITE_WEBSOCKETS_URL as string | undefined;
  if (wsUrl) {
    const base = wsUrl
      .replace(/^wss:\/\//, "https://")
      .replace(/^ws:\/\//, "http://");
    const pathBase = base
      .replace(/\/+$/, "")
      .replace("/ws/widgets/", "/api/widgets/");
    return `${pathBase}/token/`;
  }
  return DEV_TOKEN_API_URL;
}

export const websocketConfig = {
  get url() {
    return getWebSocketUrl();
  },
  get tokenApiUrl() {
    return getTokenApiUrl();
  },
  reconnect: {
    maxAttempts: 5,
    initialDelay: 1000,
    maxDelay: 30000,
  },
  heartbeat: {
    enabled: true,
    interval: 30000,
  },
} as const;
